import { render, staticRenderFns } from "./skuInfo.vue?vue&type=template&id=f0c6d6f4&scoped=true"
import script from "./skuInfo.vue?vue&type=script&lang=js"
export * from "./skuInfo.vue?vue&type=script&lang=js"
import style0 from "./skuInfo.vue?vue&type=style&index=0&id=f0c6d6f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c6d6f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0c6d6f4')) {
      api.createRecord('f0c6d6f4', component.options)
    } else {
      api.reload('f0c6d6f4', component.options)
    }
    module.hot.accept("./skuInfo.vue?vue&type=template&id=f0c6d6f4&scoped=true", function () {
      api.rerender('f0c6d6f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/skuInfo.vue"
export default component.exports